import tippy from 'tippy.js';

export function initialize(/* application */) {
  tippy.setDefaultProps({
    placement: 'right-start',
    animation: 'shift-away',
    theme: 'scaleflow',
    arrow: false,
    offset: [-6, 8],
  });
}

export default {
  initialize,
};
